<h2 mat-dialog-title>{{ 'DialogWarning.Title' | translate }}</h2>
<mat-dialog-content class="mat-typography">
  <div class="warning-content">
    <div class="icon">
      <mat-icon>warning</mat-icon>
    </div>
    <div class="warning-text">
      {{ data.message | translate }}
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.showCancelButton === true) {
    <button mat-button [mat-dialog-close]="false">
      {{ 'Buttons.Cancel' | translate }}
    </button>
  }
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
    {{ 'Buttons.Ok' | translate }}
  </button>
</mat-dialog-actions>
